module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/facility-27865b6d36999eac83a5b857a5f7d5df.webp";